import { useEffect } from "react";
import { useState } from "react";
import ReactPaginate from "react-paginate";
import { Outlet, useNavigate } from "react-router-dom";
import { FormAction, FormProps } from "../../../interfaces/form-action-interfaces";
import { Card, CardHeader, CardBody, CardFooter } from "../../forms/components/card";
import { PageTitle } from "../../forms/components/page-title";
import { Table } from "../../forms/components/table";
import { SiteData } from "../interfaces/site-result.interface";
import { GetAllSiteParam } from "../providers/site.provider";
import { useSiteStore } from "../states/site.state";

export const SiteLayout = () => {
  return (
    <>
      <PageTitle
        title={'Site'}
        subtitle={'This is an example dashboard created using build-in elements and components.'}
      />
      <Outlet/>
    </>
  );
}

export const SiteScreen = () => {

  const { sites, getSites, siteModel, onDeleteSite } = useSiteStore();
  const [siteParams, setSiteParams] = useState<GetAllSiteParam>({ page: 0, limit: 10 });
  const navigate = useNavigate();

  useEffect(() => {
    getSites(siteParams);
  }, [])

  const handlePageClick = (e: any) => {
    const selectedPage = e.selected + 1;
    setSiteParams({ 
      ...siteParams,
      page: selectedPage
    })
  }

  const handleOnEdit = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: SiteData) => {
    e.preventDefault();
    navigate('form', {
      state: {
        action: FormAction.UPDATE,
        title: 'Site',
        subtitle: 'Form Site',
        id: item.id,
      } as FormProps
    });
  }

  const handleOnView = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, item: SiteData) => {
    e.preventDefault();
    navigate('form', {
      state: {
        action: FormAction.VIEW,
        title: 'Site',
        subtitle: 'Form Site',
        id: item.id
      } as FormProps
    });
  }

  return (
    <>
      <Card>
        <CardHeader title={'Site'}>
          {/* <div className="btn-actions-pane-right">
            <button 
              className="btn btn-outline-success"
              onClick={(e) => {
                e.preventDefault();
                navigate('form', {
                  state: {
                    action: FormAction.CREATE,
                    title: 'Site',
                    subtitle: 'Form Site'
                  } as FormProps
                });
              }}>
              <i className="fa fa-plus"></i>
            </button>
          </div> */}
        </CardHeader>
        <CardBody clean={true}>
          <Table
            data={sites}
            actionButton={(index, item) => {
              let data: SiteData = item as SiteData;
              return (
                <div role={'group'} className="btn-group-sm btn-group btn-group-toggle">
                  {
                    <>
                      <button type="button" className="btn btn-primary" onClick={(e) => handleOnView(e, data)}>View</button>
                      {/* <button type="button" className="btn btn-danger" onClick={e => onDeleteSite(data.id, siteParams)}>Delete</button> */}
                      <button type="button" className="btn btn-warning" onClick={e => handleOnEdit(e, data)}>Edit</button>
                    </>
                  }
                </div>
              );
            }}
          />
        </CardBody>
        {/* <CardFooter>
          <ReactPaginate
            previousLabel={"«"}
            nextLabel={"»"}
            breakLabel={"..."}
            breakClassName={"page-item"}
            breakLinkClassName={"page-link"}
            previousClassName={"page-item"}
            previousLinkClassName={"page-link"}
            nextClassName={"page-item"}
            nextLinkClassName={"page-link"}
            pageCount={siteModel?.data?.meta?.totalPages}
            marginPagesDisplayed={2}
            pageRangeDisplayed={10}
            onPageChange={handlePageClick}
            containerClassName={"pagination pagination-sm m-0 float-right"}
            pageClassName={"page-item"}
            pageLinkClassName={"page-link"}
            activeClassName={"active"}
          />
        </CardFooter> */}
      </Card>
    </>
  );
}